import { createContext, useContext, useMemo, type ReactNode } from 'react';

export interface IApiScope {
  shareToken?: string;
}

const EMPTY_SCOPE: IApiScope = {};

const ApiScopeContext = createContext<IApiScope>(EMPTY_SCOPE);

export function ApiScopeProvider({
  shareToken,
  children,
}: {
  shareToken?: string;
  children: ReactNode;
}) {
  const scope = useMemo<IApiScope>(() => ({ shareToken }), [shareToken]);

  return (
    <ApiScopeContext.Provider value={scope}>
      {children}
    </ApiScopeContext.Provider>
  );
}

export function useApiScope(): IApiScope {
  return useContext(ApiScopeContext);
}
